module.exports = __webpack_public_path__ + "img/yuugi hoshiguma_lw.84b9a243.png";